import type { FC, ReactNode } from "react"

import { getInventoryLotKey } from "../../utils"

import type { InventoryByPalletItemLot } from "@/graphql/codegen/graphql"

interface ProductInventoryPalletLotListCellProps {
  lots: InventoryByPalletItemLot[] | null | undefined
  render: (lot: InventoryByPalletItemLot) => ReactNode
}

export const ProductInventoryPalletLotListCell: FC<ProductInventoryPalletLotListCellProps> = ({ lots, render }) => (
  <div className='flex flex-col gap-y-1'>
    {(lots ?? []).map((lot) => (
      <div key={getInventoryLotKey(lot)} className='whitespace-nowrap'>
        {render(lot)}
      </div>
    ))}
  </div>
)
